/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomebanneredit2Inputs */

const en_outcomebanneredit2 = /** @type {(inputs: Outcomebanneredit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const pt_outcomebanneredit2 = /** @type {(inputs: Outcomebanneredit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Outcomebanneredit2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomebanneredit2 = /** @type {((inputs?: Outcomebanneredit2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomebanneredit2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomebanneredit2(inputs)
	return pt_outcomebanneredit2(inputs)
});
export { outcomebanneredit2 as "outcomeBannerEdit" }